<template>
	<div class="fullPage"    >
		<!-- Header -->
		<v-layout class="pa-5 guideHeader" >			
			<v-layout  justify-end align-center>  
				<v-flex>
					<v-btn class="mr-2" icon @click="setMenuOpen(true)"><v-icon>menu</v-icon></v-btn>         
				</v-flex>
	            <v-flex shrink>
	            </v-flex>
	            <v-flex class="topTitlePhone" style="">
	            	<v-layout row>
	            	<img src="https://interactivefloorplans.arizona.edu/static/img/ua_block_rgb_3.3c82a4c.3c82a4c.png" class="phoneBlocka mr-5">
	                <div class="display-1">About Room Finder</div>
	            	</v-layout>
	            </v-flex>
	            <v-flex style="" class="text-xs-right">
	         	</v-flex>
        	</v-layout>
        </v-layout>

        <!-- Lower Area -->	
         

		<v-layout fill-height style="margin-top: 120px; margin-left:40px;">
			<v-flex class="contentArea" >
				<div class="body-1 scrollContent" style="height:100%;">
					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title class="mb-5">Room Finder</v-card-title>
						<v-card-text class="px-4">
							Room Finder is an application to show a highlighted room or building on a map.  This is a service of the UA Planning Development & Facilities Management - Information Technology.
						</v-card-text>
					</v-card>

					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title class="mb-5">Technology</v-card-title>
						
						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Space Database & API
							</div>
							<span>The UA Space Database is built using MS SQL Server.  Data is served via JSON REST API.  </span>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Floorplans
							</div>
							<span>PDFM Space Management maintains CAD floorplans for hundreds of buildings. Seperate layers are maintained for room polygons, line detail, and text</span>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								GIS Technology
							</div>
							<span>CAD Floorplans are georeferenced, rooms are converted into GIS features and joined by unique key to the Space Database. GIS Room Features are united into floorwide layers, and served through ESRI GIS Server as map services.  Updates are processed automatically each night.<br><br>UA Enterprise GIS also provides the underlying basemap and building features.</span>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Room Finder Application
							</div>
							<span>Room Finder is a custom javascript application created with Vue.js, Vuetify and ESRI Javascript API.   </span>
						</v-card-text>
					</v-card>

					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title class="mb-5">Contact</v-card-title>
						<v-card-text class="px-4">
							If you have questions or comments regarding Room Finder please contact:<br>
							<a href="mailto:drennen@arizona.edu">Drennen Brown - Director Information Technology, Planning Development & Facilities Management</a>
						</v-card-text>
					</v-card>
				</div>
			</v-flex>

		</v-layout>


	</div>

</template>

<script>

//import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {

	data () {
	    return {
	    }
	},

	computed: {
		...mapState({	
					}),
	},

	mounted: function() {
	},


	methods: {
		...mapMutations(['setMenuOpen' ]),
		...mapActions(['']),
	}
}

</script>



<style>

.fullPage {
	height: 50px;
	background-color: black;
}

.guideHeader {
	position: fixed;
	background-color: rgb(250, 250, 250);
	width: 100%;
	height: 100px;
	box-shadow: 0px 0px 10px -2px #000;
	z-index: 2;
}

.lowerPortion {
	position: relative;
	top: 120px;
	padding-left: 80px;
	overflow-y: auto;
}

.contentArea {
	height: calc(100vh - 170px);	
	
}

.scrollContent {
	padding-right: 30px;
	overflow-y: auto;
}

.fakeURL {
	text-decoration: underline;
	cursor: pointer;
}

.map {
	height:100%; 
	text-align: center; 
}

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(200, 200, 200); 
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .1); 
} 

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, .3);  
}

/* Buttons */
::-webkit-scrollbar-button:single-button {
  background-color: rgb(250, 250, 250);
  display: block;
  border-style: solid;
  height: 8px;
  width: 10px;
}

/* Up */
::-webkit-scrollbar-button:single-button:vertical:decrement {
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #555555 transparent;
}

::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
  border-color: transparent transparent #777777 transparent;
}
/* Down */
::-webkit-scrollbar-button:single-button:vertical:increment {
  border-width: 5px 5px 0 5px;
  border-color: #555555 transparent transparent transparent;
}
</style>
